// utils/walletHelpers.js
export const getWalletStatus = (anoReferencia) => {
    if (!anoReferencia) return 'loading';
    
    // Converte para número caso venha como string
    const ano = Number(anoReferencia);
    
    // Regra: Se o ano é 2025, expira em 31/03/2026
    // O objeto Date usa mês baseado em zero (Janeiro = 0, Março = 2)
    const validadeDate = new Date(ano + 1, 2, 31, 23, 59, 59);
    
    const hoje = new Date();
    
    // Diferença em milissegundos para dias
    const diffTime = validadeDate - hoje;
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    if (diffDays < 0) return 'expired';
    
    // Retorna 'warning' se estiver a 30 dias ou menos do dia 31/03
    if (diffDays <= 30) return 'warning'; 
    
    return 'active';
};
